import { Lock } from "lucide-react";
import type { ReactNode } from "react";

interface Props {
  label: string;
  icon?: ReactNode;
  active?: boolean;
  locked?: boolean;
  onClick?: () => void;
}

export function SidebarItem({ label, icon, active, locked, onClick }: Props) {
  const base =
    "w-full text-left px-3 py-2 rounded-md text-sm flex items-center gap-2.5 transition-colors";
  const cls = active
    ? "bg-indra-turquesa-muted border-l-2 border-indra-turquesa text-white font-semibold"
    : locked
      ? "text-white/30 cursor-not-allowed"
      : "text-white/70 hover:bg-white/5 hover:text-white";

  return (
    <button
      type="button"
      disabled={locked}
      onClick={!locked ? onClick : undefined}
      className={`${base} ${cls}`}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <span className="flex-1 truncate">{label}</span>
      {locked && <Lock size={12} className="opacity-60" />}
    </button>
  );
}
